var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "shop-header" }, [
    _c("div", { staticClass: "shop-header__title" }, [
      _vm.titleText
        ? _c("span", {
            directives: [
              {
                name: "sanitize",
                rawName: "v-sanitize",
                value: _vm.titleText,
                expression: "titleText"
              }
            ],
            staticClass: "shop-header__title-main"
          })
        : _vm._e(),
      _vm._v(" "),
      _vm.subTitleText
        ? _c("span", {
            directives: [
              {
                name: "sanitize",
                rawName: "v-sanitize",
                value: _vm.subTitleText,
                expression: "subTitleText"
              }
            ],
            staticClass: "shop-header__title-sub"
          })
        : _vm._e()
    ]),
    _vm._v(" "),
    _vm.isLoggedIn && (_vm.user.groups.length || _vm.accountPoinzCount)
      ? _c(
          "ul",
          { staticClass: "shop-header__info" },
          [
            _vm._l(_vm.user.groups, function(group, index) {
              return _c(
                "li",
                {
                  key: "group-" + index,
                  staticClass: "shop-header__info-item"
                },
                [
                  _c("span", {
                    staticClass: "shop-header__info-item-value",
                    domProps: { innerHTML: _vm._s(group.value) }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "shop-header__info-item-name",
                    domProps: { innerHTML: _vm._s(group.name) }
                  })
                ]
              )
            }),
            _vm._v(" "),
            _vm.accountPoinzCount
              ? _c("li", { staticClass: "shop-header__info-item" }, [
                  _c("span", {
                    staticClass: "shop-header__info-item-value",
                    domProps: { innerHTML: _vm._s(_vm.accountPoinzCount) }
                  }),
                  _vm._v(" "),
                  _c("span", {
                    staticClass: "shop-header__info-item-name",
                    domProps: {
                      innerHTML: _vm._s(
                        _vm.$t("shoplist.shopHeader.poinzLabel")
                      )
                    }
                  })
                ])
              : _vm._e()
          ],
          2
        )
      : !_vm.isLoggedIn &&
        (_vm.hasFeature("FEATURE_ACCOUNT") ||
          _vm.hasFeature("FEATURE_ACCOUNT_LOGGEDIN"))
      ? _c(
          "div",
          { staticClass: "shop-header__login" },
          [
            _c("span", {
              staticClass: "shop-header__login-text",
              domProps: { innerHTML: _vm._s(_vm.loginText) }
            }),
            _vm._v(" "),
            _c("Button", {
              staticClass: "shop-header__login-button",
              attrs: {
                text: _vm.$t("shoplist.shopHeader.loginButton"),
                type: "button",
                level: "tertiary",
                arrow: "",
                disabled: _vm.disabled
              },
              on: {
                click: function($event) {
                  $event.preventDefault()
                  return _vm.onLoginClick.apply(null, arguments)
                }
              }
            })
          ],
          1
        )
      : _vm._e()
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }